export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_FROM = 'SET_FROM';
export const UPDATE_NAV_ITEM_STATE = 'UPDATE_NAV_ITEM_STATE';

export const LOAD_RULES = 'LOAD_RULES';
export const DESTROY_RULES = 'DESTROY_RULES';

export const USER_LOGGED_IN = 'USER_LOGGED_IN';
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT';
export const USER_PROFILE_LOAD = 'USER_LOGGED_LOAD';
export const USER_CP_LOAD = 'USER_CP_LOAD';

export const USERS_LOAD = 'USERS_LOAD';
export const PERMISSIONS_LOAD = 'PERMISSIONS_LOAD';
export const TOKENS_LOAD = 'TOKENS_LOAD';
export const ROLES_LOAD = 'ROLES_LOAD';
export const COUNTRIES_LOAD = 'COUNTRIES_LOAD';
export const COMPANIES_LOAD = 'COMPANIES_LOAD';
export const FIREWALLS_LOAD = 'FIREWALLS_LOAD';
export const LIABILITY_COUNTERS_LOAD = 'LIABILITY_COUNTERS_LOAD';
export const LOTTERY_EVENTS_LOAD = 'LOTTERY_EVENTS_LOAD';
export const LOTTERY_SYSTEMS_LOAD = 'LOTTERY_SYSTEMS_LOAD';
export const SHOPGROUPS_LOAD = 'SHOPGROUPS_LOAD';
export const DEVICES_LOAD = 'DEVICES_LOAD';
export const SHOPS_LOAD = 'SHOPS_LOAD';
export const TENANTS_LOAD = 'TENANTS_LOAD';
export const TERMINALS_LOAD = 'TERMINALS_LOAD';
export const BALANCE_LOAD = 'BALANCE_LOAD';
export const TICKETS_LOAD = 'TICKETS_LOAD';
export const AUDITS_LOAD = 'AUDITS_LOAD';
export const CASH_RESULTS_LOAD = 'CASH_RESULTS_LOAD';
export const PLAYERS_LOAD = 'PLAYERS_LOAD';
export const ONLINE_PLAYERS_LOAD = 'ONLINE_PLAYERS_LOAD';
export const THIRD_PARTY_PLAYERS_LOAD = 'THIRD_PARTY_PLAYERS_LOAD';
export const PRODUCTS_LOAD = 'PRODUCTS_LOAD';
export const BANKS_LOAD = 'BANKS_LOAD';
export const OPERATORS_LOAD = 'OPERATORS_LOAD';
export const SUBTYPES_LOAD = 'SUBTYPES_LOAD';
export const SLOTS_LOAD = 'SLOTS_LOAD';
export const SHOP_CASH_TX_LOAD = 'SHOP_CASH_TX_LOAD';
export const JACKPOTS_LOAD = 'JACKPOTS_LOAD';

export const CACHE_INVALIDATE = 'CACHE_INVALIDATE';
export const CACHE_INVALIDATE_ALL = 'CACHE_INVALIDATE_ALL';
export const CACHE_LOAD = 'CACHE_LOAD';

export const CACHE_ON_DEMAND_INVALIDATE = 'CACHE_ON_DEMAND_INVALIDATE';
export const CACHE_ON_DEMAND_LOAD = 'CACHE_ON_DEMAND_LOAD';

export const NOTIFICATION_ADD = 'NOTIFICATION_ADD';
export const NOTIFICATION_REMOVE = 'NOTIFICATION_REMOVE';
export const NOTIFICATIONS_CLEAR = 'NOTIFICATIONS_CLEAR';
export const NOTIFICATIONS_NEW_CLEAR = 'NOTIFICATIONS_NEW_CLEAR';
export const NOTIFICATIONS_CHECK = 'NOTIFICATIONS_CHECK';
